// @flow
import axios from "axios";
import config from "../config";
// axios.interceptors.response.use(function (config) {
//     // Do something before request is sent
//     return config;
//   }, function (error) {
//     // Do something with request error
//     console.log(error.response);
//     return Promise.reject(error);
//   });

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
const { API_URL } = config;
type objectType = { [key: string]:  any };

export const post = async (
  url: string,
  body: objectType | Array<objectType> = {},
  headers: objectType = {},
  cancel: boolean = false
) => {
    try {
      let parsedUrl = url;
      if (url.search(/^http(s)?:\/\//) < 0) {
        parsedUrl = API_URL + url;
      }

      const res = await axios.post(parsedUrl, body, {
        headers,
        cancelToken: source.token
      });
      return res.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        throw error;
      } else {
        throw error;
      }
    }
};

export const get = async (
  url: string,
  queryParams: objectType = {},
  headers: objectType = {}
) => {
  let parsedUrl = url;
  if (url.search(/^http(s)?:\/\//) < 0) {
    parsedUrl = API_URL + url;
  }

  const res = await axios.get(parsedUrl, {
    params: queryParams,
    headers,
    cancelToken: source.token
  });

  return res.data;
};
